import { render, staticRenderFns } from "./cancer-classification-page.html?vue&type=template&id=3a21fe59&scoped=true&external"
import script from "./cancer-classification-page.js?vue&type=script&lang=js&external"
export * from "./cancer-classification-page.js?vue&type=script&lang=js&external"
import style0 from "./cancer-classification-page.scss?vue&type=style&index=0&id=3a21fe59&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a21fe59",
  null
  
)

export default component.exports